<template>
    <main class="no-frontpage program">
        <div class="container">
            <Loader v-show="isLoading"/>
            <div v-show="!isLoading" class="row">
                <div class="col-md-9 col-xs-12" v-if="program && !failed">
                    <Description :program="program"/>
                    <TreeMap :program="program" v-if="hasProducts" :year="year"></TreeMap>
                    <hr>
                    <section >
                        <YearControl :program="program" :availableYears="availableYears" :year="year"/>
                        <hr>
                        <section v-if="hasProducts">
                            <div class="row justify-content-between form-inline options">
                                <div class="col-md-12 col-lg-6 form-group">
                                    <input class="form-control" type="text" placeholder="Buscar..." id="filter" v-model="filter">
                                </div>
                                <div class="col-lg-auto col-sm-12 form-group  d-none d-md-block">
                                    <label class="col-form-label mr-3">Ordenar por: </label>
                                    <button class="form-control" @click="sortByTitle">
                                        <i :class="[titleSort == -1 ? 'fa-sort-alpha-down' : 'fa-sort-alpha-up', 'fas mr-2']"></i>
                                        <span>Título</span>
                                    </button>
                                    <button class="form-control ml-2" @click="sortByDate">
                                        <i :class="[dateSort == -1 ? 'fa-sort-numeric-down' : 'fa-sort-numeric-up', 'fas mr-2']"></i>
                                        <span>Fecha</span>
                                    </button>
                                </div>
                            </div>
                            <template v-for="product in program.products">
                                <Product :key="product.code" :product="product" :year="year"></Product>
                            </template>
                        </section>
                        <section v-else>
                            <h2>Aún no hay productos registrados este año <b>({{year}})</b> en este Programa Presupuestal 😅. Por favor, selecione otro año</h2>
                        </section>
                    </section>
                </div>
                <div v-else class="col-md-9 col-xs-12">
                    <Error :error="error" v-if="failed"/>
                </div>
                <div class="col-md-3 col-xs-12">
                    <div class="sidebar">
                        <slot name="sidebar">Can not charge the sidebar :(</slot>
                        <Tree :program="program" v-if="hasProducts" v-on:update-visibility="updateVisibility"></Tree>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { getProgram, getYearsByProgram } from "@/api.js";
import Loader from "@/components/Loader";
import Tree from "@/components/TreeView/Tree";
import TreeMap from "@/components/TreeMap";
import Description from "@/components/Program/Description";
import Product from "@/components/Product.vue";
import YearControl from '../components/Program/YearControl.vue';
import Error from "@/components/Error.vue";

export default {
    name: "Programa",
    data() {
        return {
            isLoading: true,
            availableYears: [],
            program: {},
            year: new Date().getFullYear(),
            hasProducts: false,
            filter: '',
            titleSort: 1,
            dateSort: 1,
            failed: false,
            error: {}
        };
    },
    created() {
        this.getData();
    },
    methods: {
        filterData() {
            //I don't want to destroy all child components, but just hide them
            this.program.products.forEach( product => {
                const ptFilter = product.title.toLowerCase().includes(this.filter.toLowerCase()) || 
                                 product.code.includes(this.filter)
                if ( ptFilter ) {
                    this.updateProductVisibility(product, true);
                }
                else {
                    var proMatch = false
                    product.activities.forEach( activity => {
                        const aFilter = activity.title.toLowerCase().includes(this.filter.toLowerCase()) || 
                                        activity.code.toLowerCase().includes(this.filter.toLowerCase())
                        if( aFilter ) {
                            this.updateActivityVisibility(activity, true);
                            proMatch = true
                        }
                        else
                        {
                            var actMatch = false
                            activity.results.forEach ( result => {
                                const aFilter = result.title.toLowerCase().includes(this.filter.toLowerCase())
                                if( aFilter ) {
                                    result.isVisible = true
                                    proMatch = true
                                    actMatch = true
                                } else {
                                    result.isVisible = false
                                }
                            })
                            activity.isVisible = actMatch
                        }
                    })
                    product.isVisible = proMatch
                }
            })
        },
        sortByTitle() {
            const altOrder = this.titleSort == 1 ? -1 : 1
            //this.programa.products.sort( (a, b) => ( a.title > b.title ) ? this.titleSort : altOrder )
            this.program.products.forEach( product => {
                //product.activities.sort( (a, b) => ( a.title > b.title ) ? this.titleSort : altOrder )
                product.activities.forEach( activity => {
                    activity.results.sort( (a, b) => ( a.title > b.title ) ? this.titleSort : altOrder )
                })
            })
            this.titleSort == 1 ? this.titleSort = -1 : this.titleSort = 1  
        },
        sortByDate() {
            const altOrder = this.dateSort == 1 ? -1 : 1
            //this.programa.products.sort( (a, b) => ( new Date(a.date) > new Date(b.date) ) ? this.dateSort : altOrder )
            this.program.products.forEach( product => {
                //product.activities.sort( (a, b) => ( new Date(a.date) > new Date(b.date) ) ? this.dateSort : altOrder )
                product.activities.forEach( activity => {
                    activity.results.sort( (a, b) => ( new Date(a.date) > new Date(b.date) ) ? this.dateSort : altOrder )
                })
            })
            this.dateSort == 1 ? this.dateSort = -1 : this.dateSort = 1  
        },
        updateProductVisibility ( node, visibility ) {
            node.isVisible = visibility;
            node.activities.forEach( activity => {
                activity.isVisible = visibility
                this.updateActivityVisibility(activity, true)
            });
        },
        updateActivityVisibility ( node, visibility ) {
            node.results.forEach( result => {
                result.isVisible = visibility
            }); 
        },
        async getData() {
            const code = String(this.$route.params.code)
            await getYearsByProgram(code)
            .then(data => {
                this.availableYears = data;
                this.year = Number(this.$route.params.year) || this.availableYears[0]  || this.year;
            })
            .then(
                async () => {
                    await getProgram(this.year, code).then(data => {
                        if(data && data.program) {
                            this.program = data.program
                            if( this.program){
                                this.checkProducts();
                                this.setVisibility();
                            }
                        }
                        this.isLoading = false;
                    });
                }
            )
            .catch(() => {
                this.error.title = "OOPS!";
                this.error.message = "El programa que está buscando no ha sido encontrado";
                this.isLoading = false;
                this.failed = true;
            });
        },
        setVisibility () {
            if ( this.hasProducts ) {
                const thisComponent = this
                this.program.products.forEach( product => {
                    thisComponent.$set(product, 'isVisible', true)
                    if(product.activities && product.activities.length) product.activities.forEach( function(activity){
                        thisComponent.$set(activity, 'isVisible', true)
                        if(activity.results && activity.results.length) activity.results.forEach( function(result){
                            thisComponent.$set(result, 'isVisible', true)
                        })
                    })
                })
            }
        },
        checkProducts() {
            this.hasProducts = this.program && this.program.products && this.program.products.length
        },
        updateVisibility(code, visibility){
            this.program.products.forEach( product => {
                if ( product.code == code ) {
                    product.isVisible = visibility;
                    return
                } else {
                    product.activities.forEach( activity => {
                        if (activity.code == code ) {
                            if ( visibility ) product.isVisible = visibility
                            activity.isVisible = visibility
                            return
                        }
                    })
                }
            })
        },

    },
    watch: {
        filter: function() {
            this.filterData()    
        }
    },
    components : {
        Loader,
        Product,
        Tree,
        TreeMap,
        Description,
        YearControl,
        Error
    }
};
</script>

<style scoped>    
    .program h5 {
        font-size: 1.2em;
    }
    .program table, .program table thead {
        width: 100%;
    }
    .sidebar {
        position: sticky;
        top: 120px;
    }
    .options {
        margin-top: 2em;
        margin-bottom: 1em;
    }
</style>
